export interface IndividualChildResultPreviewContract {
  uuid: string;
  child_uuid: string;
  test_uuid: string;
  finished_at: string;
  started_at: string;
}
